/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Component } from 'react'
import {
  withStyles,
  Hidden,
  CircularProgress,
  LinearProgress,
  Menu,
  MenuItem,
} from '@material-ui/core'
import { Auth } from 'aws-amplify'
import './index.css'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { openSnackbar } from 'actions/view'
import { AuthState } from '@aws-amplify/ui-components'
import US from 'utils/flags/US.png'
import CA from 'utils/flags/CA.png'
import { withRouter } from 'react-router-dom'
import Field from 'components/theme/Field'
import Button from 'components/theme/Button'
import withRoot from 'components/withRoot'
import { API_URL } from 'utils/AllURLs'
import { userSignOut } from 'actions/auth'
import Link from 'utils/Link'

const urlParams = new URLSearchParams(window.location.search)
const name = urlParams.get('name')
const nameArr = name?.split?.(' ')
const firstName = nameArr?.[0]
const lastName = nameArr?.[nameArr?.length - 1]
const email = urlParams.get('email')
const mobile = urlParams.get('mobile')
const utcexp = urlParams.get('utcexp')
const templver = urlParams.get('templver')
const reqtok = urlParams.get('reqtok_v1')
const acctID = urlParams.get('acctID')
const id = urlParams.get('id')
const jwtToken = urlParams.get('jwtToken')
const inviter_email = urlParams.get('inviter_email')
const inviter_fullname = urlParams.get('inviter_fullname')
const inviter_company = urlParams.get('inviter_company')
// const devOrProdKey =
//   window?.location?.href?.slice?.(0, 29) === 'https://console.vastreach.com'
//     ? '2j1q69p1gd5mk75aape1ck8arg'
//     : '68t3ue2bjp3tdl6177i68nrpf4'

const countryToCodeObj = { US: '+1', CA: '+1' }
const countryToFlagObj = { US: US, CA: CA }

const styles = theme => ({
  form: {
    maxWidth: 460,
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '35px 40px',
    textAlign: 'left',
    width: '90%',
    borderRadius: 35,
    boxSizing: 'border-box',
    boxShadow: 'rgba(0, 0, 0, 0.15) 1px 1px 4px 0px',
    marginBottom: 20,
  },
  signupForm: {
    backgroundColor: '#fff',
    padding: '35px 40px',
    textAlign: 'left',
    color: '#333',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  label: {
    paddingBottom: '0.5em',
    fontSize: 14,
    // color: 'rgb(21, 41, 57)',
    color: '#fff',
    position: 'relative',
    fontWeight: 'normal',
  },
  signupLabel: {
    paddingBottom: '0.5em',
    fontSize: 14,
    color: '#333',
    position: 'relative',
    fontWeight: 'normal',
  },
  input: {
    margin: '0 0 0.625rem 0',
    display: 'block',
    width: '100%',
    padding: '1rem',
    fontSize: 14,
    color: 'rgb(21, 41, 57)',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    height: '3.125rem',
    lineHeight: '1.1',
    border: '1px solid rgb(196, 196, 196)',
    borderRadius: 25,
  },
  footer: {
    fontSize: 14,
    display: 'flex',
    color: '#333',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginTop: 13,
  },
  logo: {
    maxWidth: 300,
    margin: '0 auto',
    display: 'block',
    backgroundColor: 'transparent',
  },
  circularProgressColorPrimary: {
    color: '#fff',
  },
  outlined: {
    borderWidth: 0,
  },
  stepper: {
    backgroundColor: 'transparent',
    padding: '20px 0',
    marginBottom: 20,
  },
  stepLabel: {
    color: '#333',
    fontSize: 12,
    textAlign: 'center',
    marginTop: 5,
    whiteSpace: 'nowrap',
  },
  stepIcon: {
    color: '#fff',
    '&$activeStepIcon': {
      color: '#00ff43',
    },
    '&$completedStepIcon': {
      color: '#00ff43',
    },
  },
  activeStepIcon: {},
  completedStepIcon: {},
  stepConnector: {
    backgroundColor: '#fff',
  },
  formContainer: {
    maxWidth: 460,
    backgroundColor: '#006fd9',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '35px 40px',
    textAlign: 'left',
    width: '90%',
    borderRadius: 35,
    boxSizing: 'border-box',
    boxShadow: 'rgba(0, 0, 0, 0.15) 1px 1px 4px 0px',
    marginBottom: 20,
    color: '#fff',
  },
  benefitsList: {
    listStyle: 'none',
    padding: 0,
    margin: '20px 0',
  },
  benefitItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10,
    color: '#333',
  },
  checkIcon: {
    color: '#00ff43',
    marginRight: 10,
  },
  formImage: {
    maxWidth: '50%',
    height: 'auto',
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      marginBottom: 20,
    },
  },
  stepContent: {
    display: 'flex',
    flexDirection: 'column',
    '& $benefitsSection': {
      order: 1,
    },
    '& $questionsSection': {
      order: 2,
    },
    '& $formFields': {
      order: 3,
    },
    '& $footerContainer': {
      order: 4,
    },
    [theme.breakpoints.down('sm')]: {
      '& $formFields': {
        order: 1,
      },
      '& $footerContainer': {
        order: 2,
      },
      '& $benefitsSection': {
        order: 3,
      },
      '& $questionsSection': {
        order: 4,
      },
    },
  },
  footerContainer: {
    width: '100%',
  },
  formFields: {
    width: '100%',
    marginTop: 20,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
  },
  benefitsSection: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '40px',
    marginBottom: 40,
    [theme.breakpoints.down('sm')]: {
      marginTop: 30,
      marginBottom: 0,
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  questionsSection: {
    textAlign: 'center',
  },
  progressContainer: {
    marginBottom: 30,
    marginTop: 20,
  },
  linearProgress: {
    height: 25,
    borderRadius: 20,
    backgroundColor: '#eee',
  },
  linearProgressColorPrimary: {
    backgroundColor: '#2979ff',
  },
  stepLabels: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 8,
  },
  stepItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  formInput: {
    margin: '0 0 1.25rem 0',
    display: 'block',
    width: '100%',
    padding: '1rem',
    fontSize: 14,
    color: 'rgb(21, 41, 57)',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    height: '3.125rem',
    lineHeight: '1.1',
    border: 'none',
    borderRadius: 25,
    '&:focus': {
      outline: 'none',
      boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.5)',
    },
    '&::placeholder': {
      color: '#888',
    },
  },
  nextButton: {
    backgroundColor: '#1a4b8c',
    color: '#fff',
    border: 'none',
    borderRadius: 25,
    padding: '12px 30px',
    fontSize: 16,
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#0d3c7d',
    },
    width: 120,
  },
  benefitsContent: {
    flex: 1,
  },
  benefitsTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 15,
    marginTop: 0,
    color: '#333',
    textAlign: 'left',
  },
  signInLink: {
    color: '#2979ff',
    textDecoration: 'underline',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    fontSize: 'inherit',
    fontFamily: 'inherit',
  },
  pageTitle: {
    textAlign: 'center',
    marginBottom: 30,
    color: '#333',
    fontSize: 40,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
  },
  mobileFooter: {
    display: 'none',
    marginTop: 20,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      '&$footer': {
        marginTop: 20,
      },
    },
  },
  desktopFooter: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
})

function stripCountryCode(phoneNumber) {
  // Check if the phone number starts with '+1'
  if (phoneNumber.startsWith('+1')) {
    // Strip the '+1' and return the rest of the number
    return phoneNumber.slice(2)
  }
  // If there is no country code, return the original number
  return phoneNumber
}

class SignUp extends Component {
  state = {
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    mobile: '',
    code: '',
    newPassword: '',
    display: 'signin',
    loading: false,
    country: 'US',
    anchorEl: null,
    activeStep: 1,
    signupSteps: [
      null,
      'Name',
      'Email',
      'Password',
      'Phone',
      'Terms of Service',
      'Confirmation Code',
    ],
    userinvitationSteps: [
      null,
      'Verify Information',
      'Password',
      'Terms of Service',
      'Confirmation Code',
    ],
    termsAccepted: false,
    invitationStatus: null,
    invitationError: null,
    showPasswordStep: false,
    showConfirmationStep: false,
  }

  componentDidMount() {
    // Check URL path to set display state
    const path = this.props.location.pathname
    if (path === '/createaccount' || path === '/signup') {
      if (this.props.alreadySignedIn) {
        this.setState({ display: 'alreadyAuthenticated' })
      } else {
        this.setState({ display: 'signup' })
      }
    }

    if (path === '/userinvitation') {
      if (this.props.alreadySignedIn) {
        this.setState({ display: 'alreadyAuthenticated' })
      } else {
        this.setState({ display: 'loading' })
        this.validateInvitation()
      }
    }

    if (firstName) {
      this.setState({ firstName })
    }

    if (lastName) {
      this.setState({ lastName })
    }

    if (email) {
      this.setState({ email, username: email })
    }

    if (mobile) {
      this.setState({ mobile: stripCountryCode(mobile) })
    }

    this.currentAuthenticatedUser()
  }

  validateInvitation = async () => {
    // gonna make this more robust later
    if (!templver || !reqtok /* || !acctID || !id || !email */) {
      this.setState({
        invitationError: 'Invalid invitation link',
        display: 'invalid',
      })
      return
    }

    try {
      const response = await fetch(
        `${API_URL}/account/public_reservation/` +
          `${acctID}/` +
          `${id}/` +
          `${encodeURIComponent(email)}/` +
          `?reqtok_v1=${reqtok}`,
      )
      const data = await response.json()
      console.log('data', data)

      if (data.status === 'O') {
        // Check if expires_at exists
        if (!data?.expires_at) {
          this.setState({ display: 'datamismatch' })
          return
        }

        const expires_at = new Date(data.expires_at)

        // Check if invitation has expired
        if (expires_at <= new Date()) {
          this.setState({ display: 'datamismatch' })
          return
        }

        // Only check date equality if utcexp is present
        if (utcexp) {
          const utcexp_date = new Date(utcexp)
          if (expires_at?.getTime?.() !== utcexp_date?.getTime?.()) {
            this.setState({ display: 'datamismatch' })
            return
          }
        }

        // If we get here, the invitation is valid
        this.setState({ invitationStatus: 'valid', display: 'userinvitation' })
      } else if (data.status === 'A') {
        // Already accepted
        this.setState({
          display: 'accepted',
        })
      } else if (data.status === 'E') {
        // Expired
        this.setState({
          display: 'expired',
        })
      } else if (data.status === 'F') {
        // Failed
        this.setState({
          display: 'failed',
        })
      } else {
        this.setState({
          display: 'invalid',
        })
      }
    } catch (error) {
      console.error('Error validating invitation:', error)
      this.setState({
        display: 'error',
      })
    }
  }

  async currentAuthenticatedUser() {
    try {
      const User = await Auth.currentAuthenticatedUser()
      if (User === null) {
        this.props.setAuthState(AuthState.SignedOut)
        this.props.setUser(null)
      } else {
        this.props.setAuthState(AuthState.SignedIn)
        this.props.setUser(User)
      }
    } catch (error) {
      console.log(error)
    }
  }

  signUp = () => {
    return new Promise((resolve, reject) => {
      if (
        this.state.username &&
        this.state.password &&
        this.state.confirmPassword &&
        this.state.email &&
        this.state.mobile &&
        this.state.firstName &&
        this.state.lastName
      ) {
        this.setState({ loading: true })
        Auth.signUp({
          username: this.state.username,
          password: this.state.password,
          attributes: {
            email: this.state.email,
            phone_number: `${
              countryToCodeObj?.[this.state.country]
            }${this.state.mobile?.replace(/\D/g, '')}`,
            given_name: this.state.firstName,
            family_name: this.state.lastName,
          },
          autoSignIn: {
            enabled: true,
          },
        }).then(
          ({ user }) => {
            this.setState({ loading: false })
            resolve(user)
          },
          err => {
            this.setState({ loading: false })
            console.log(err)
            this.props.openSnackbar({ type: 'error', message: err?.message })
            reject(err)
          },
        )
      } else {
        const error = new Error('All fields must be filled out')
        this.props.openSnackbar({
          type: 'error',
          message: error.message,
        })
        reject(error)
      }
    })
  }

  signIn = () => {
    if (this.state.username && this.state.password) {
      this.setState({ loading: true })
      Auth.signIn(this.state.username, this.state.password).then(
        user => {
          console.log(user)
          Promise.resolve().then(() => {
            this.setState({ loading: false })
            this.props.setAuthState(AuthState.SignedIn)
            this.props.setUser(user)
          }) /* .then(() => {
            return window?.location?.replace?.(window?.location?.origin)
          }) */
        },
        err => {
          this.setState({ loading: false })
          if (err?.code === 'UserNotConfirmedException') {
            this.setState({ display: 'confirmSignup' })
          } else if (err?.code === 'PasswordResetRequiredException') {
            console.log(err)
            this.setState({ display: 'resetPassword' })
            this.props.openSnackbar({
              type: 'error',
              message: err?.message,
            })
          } else {
            console.log(err)
            this.props.openSnackbar({ type: 'error', message: err?.message })
          }
        },
      )
    }
  }

  confirmSignUp = () => {
    this.setState({ loading: true })
    Auth.confirmSignUp(this.state.username, this.state.code).then(
      data => {
        this.setState({ loading: false })
        console.log(data)
        this.signIn()
        // return window?.location?.replace?.(window?.location?.origin)
        // Navigate to onboarding after successful sign in
        // this.props.history.push('/onboarding')

        // doing this for now until the onboarding screen is ready
        this.props.history.push('/')
      },
      err => {
        this.setState({ loading: false })
        console.log(err)
        this.props.openSnackbar({ type: 'error', message: err?.message })
      },
    )
  }

  handleNext = () => {
    // Validate fields based on current step
    if (this.state.activeStep === 1) {
      if (!this.state.firstName || !this.state.lastName) {
        this.props.openSnackbar({
          type: 'error',
          message: 'Please fill in both first and last name',
        })
        return
      }
    }

    if (this.state.activeStep === 2) {
      if (!this.state.email) {
        this.props.openSnackbar({
          type: 'error',
          message: 'Please enter your email address',
        })
        return
      }
      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.state.email)) {
        this.props.openSnackbar({
          type: 'error',
          message: 'Please enter a valid email address',
        })
        return
      }
    }

    if (this.state.activeStep === 3) {
      if (!this.validatePassword()) {
        return
      }
    }

    if (this.state.activeStep === 4) {
      if (!this.state.mobile) {
        this.props.openSnackbar({
          type: 'error',
          message: 'Please enter your phone number',
        })
        return
      }
      // Basic phone number validation (numbers only)
      if (!/^\d+$/.test(this.state.mobile.replace(/\D/g, ''))) {
        this.props.openSnackbar({
          type: 'error',
          message: 'Please enter a valid phone number',
        })
        return
      }
    }

    if (this.state.activeStep === 5 && !this.state.termsAccepted) {
      this.props.openSnackbar({
        type: 'error',
        message: 'Please accept the Terms of Service to continue',
      })
      return
    }

    if (this.state.activeStep === 6) {
      if (!this.state.code) {
        this.props.openSnackbar({
          type: 'error',
          message: 'Please enter the verification code',
        })
        return
      }
    }

    this.setState(prevState => ({
      activeStep: prevState.activeStep + 1,
    }))

    if (this.state.activeStep === 5) {
      this.signUp()
    } else if (this.state.activeStep === 6) {
      this.confirmSignUp()
    }
  }

  handleBack = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep - 1,
    }))
  }

  validatePassword = () => {
    if (!this.state.password || !this.state.confirmPassword) {
      this.props.openSnackbar({
        type: 'error',
        message: 'Please fill in both password fields',
      })
      return false
    }
    if (this.state.password !== this.state.confirmPassword) {
      this.props.openSnackbar({
        type: 'error',
        message: 'Passwords do not match',
      })
      return false
    }
    if (this.state.password.length < 8) {
      this.props.openSnackbar({
        type: 'error',
        message: 'Password must be at least 8 characters long',
      })
      return false
    }

    // Check for at least 1 number
    if (!/\d/.test(this.state.password)) {
      this.props.openSnackbar({
        type: 'error',
        message: 'Password must contain at least 1 number',
      })
      return false
    }

    // Check for at least 1 uppercase letter
    if (!/[A-Z]/.test(this.state.password)) {
      this.props.openSnackbar({
        type: 'error',
        message: 'Password must contain at least 1 uppercase letter',
      })
      return false
    }

    // Check for at least 1 lowercase letter
    if (!/[a-z]/.test(this.state.password)) {
      this.props.openSnackbar({
        type: 'error',
        message: 'Password must contain at least 1 lowercase letter',
      })
      return false
    }

    // Check for at least 1 special character
    const specialChars = /[\^$*.[\]{}()?!\-@#%&/\\,><':;|_~`+=\s]/
    if (!specialChars.test(this.state.password)) {
      this.props.openSnackbar({
        type: 'error',
        message: 'Password must contain at least 1 special character',
      })
      return false
    }

    // Check for leading/trailing spaces (not allowed)
    if (
      this.state.password.startsWith(' ') ||
      this.state.password.endsWith(' ')
    ) {
      this.props.openSnackbar({
        type: 'error',
        message: 'Password cannot begin or end with a space',
      })
      return false
    }

    return true
  }

  render() {
    const { classes, history, userSignOut } = this.props
    const { activeStep, signupSteps, userinvitationSteps } = this.state

    // Change from function to const
    const PasswordStep = (
      <>
        <div className={classes.benefitsTitle}>🔐 Create a password</div>
        <Field
          label="Password"
          placeholder="Enter your password"
          value={this.state.password}
          onChange={e => this.setState({ password: e?.target?.value })}
          type="password"
        />
        <Field
          label="Confirm Password"
          placeholder="Confirm your password"
          value={this.state.confirmPassword}
          onChange={e => this.setState({ confirmPassword: e?.target?.value })}
          type="password"
          error={
            this.state.confirmPassword &&
            this.state.password !== this.state.confirmPassword
              ? `Password's don't match`
              : null
          }
          helperText="Password must be at least 8 characters long, contain at least 1 number, 1 uppercase letter, 1 lowercase letter, and 1 special character"
        />
      </>
    )

    const TermsOfServiceStep = (
      <>
        <div className={classes.benefitsTitle}>⚖️ Terms of Service</div>
        <div style={{ marginBottom: '20px' }}>
          <label
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          >
            <input
              type="checkbox"
              checked={this.state.termsAccepted}
              onChange={e => this.setState({ termsAccepted: e.target.checked })}
              style={{ marginRight: '10px' }}
            />
            <span>
              I agree to the{' '}
              <Link
                href="https://vastreach.com/terms-of-service/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#2979ff' }}
              >
                Terms of Service
              </Link>{' '}
              and{' '}
              <Link
                href="https://vastreach.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#2979ff' }}
              >
                Privacy Policy
              </Link>
            </span>
          </label>
        </div>
      </>
    )

    const ConfirmationCodeStep = (
      <>
        <div className={classes.benefitsTitle}>Confirm your account</div>
        <div style={{ marginBottom: '20px' }}>
          Please enter the verification code sent to your phone
        </div>
        <Field
          label="Verification Code"
          placeholder="Enter your code"
          value={this.state.code}
          onChange={e => this.setState({ code: e?.target?.value })}
          type="text"
        />
        <div style={{ marginTop: '10px' }}>
          <button
            onClick={() => Auth.resendSignUp(this.state.username)}
            className={classes.signInLink}
          >
            Resend code
          </button>
        </div>
      </>
    )

    const countryCodeDropdownStyles = {
      padding: '0.75rem 1.75rem 1rem 1rem',
      width: '28%',
      display: 'inline-block',
      height: '3.125rem',
      border: '1px solid rgb(0, 0, 0, 0.23)',
      borderRight: 'none',
      backgroundSize: '6px 5px, 6px 5px, 0px 1.5em',
      margin: 0,
      borderRadius: '25px 0 0 25px',
      boxSizing: 'border-box',
      appearance: 'none',
      backgroundPosition:
        'calc(100% - 1rem) calc(1em + 0.5rem), calc(100% - 0.7rem) calc(1em + 0.5rem), calc(100% - 2.5em) 0.5em',
      fontSize: 14,
      backgroundImage:
        'linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc)',
      backgroundRepeat: 'no-repeat',
      color: '#000',
      backgroundColor: '#fff',
      verticalAlign: 'top',
      cursor: 'pointer',
    }

    const benefitsSection =
      activeStep === 1 ? (
        <div className={classes.benefitsSection}>
          <Hidden smDown>
            <img
              src="/cross-platform.png"
              alt="Forms on multiple devices"
              className={classes.formImage}
            />
          </Hidden>
          <div className={classes.benefitsContent}>
            <h4 className={classes.benefitsTitle}>
              With your free trial you get to
            </h4>
            <ul className={classes.benefitsList}>
              <li className={classes.benefitItem}>
                🔥 Design Forms and Surveys
              </li>
              <li className={classes.benefitItem}>
                📧 Build Email and Text Message Templates
              </li>
              <li className={classes.benefitItem}>
                📇 Import and Enagage with Your Contacts
              </li>
              <li className={classes.benefitItem}>
                🚀 Launch Marketing Campaigns
              </li>
              <li className={classes.benefitItem}>
                🤖 Create and Train Your Own AI
              </li>
            </ul>
          </div>
        </div>
      ) : null

    const questionsSection =
      activeStep === 1 ? (
        <div className={classes.questionsSection}>
          <h4 className={classes.benefitsTitle} style={{ textAlign: 'center' }}>
            Questions? Text an expert today:{' '}
            <a style={{ color: '#2979ff' }} href="tel:+18605445120">
              +1 (860) 544-5120
            </a>
          </h4>
          <div style={{ fontSize: 12, color: '#aaa' }}>
            Answer a few questions and we'll get you into your free trial.
            <br />
            Complete the form to get started. Our team will be in touch to help
            you make the most your experience.
          </div>
        </div>
      ) : null

    const displayObj = {
      signup: (
        <div className={classes.signupForm}>
          {/* Progress Bar */}
          <div className={classes.progressContainer}>
            <LinearProgress
              variant="determinate"
              value={(activeStep / (signupSteps.length - 1)) * 100}
              className={classes.linearProgress}
              classes={{
                barColorPrimary: classes.linearProgressColorPrimary,
              }}
            />
            {/* <div className={classes.stepLabels}>
              {steps.map((label, index) => (
                <div
                  key={label}
                  className={classes.stepLabel}
                  style={{
                    color: activeStep >= index ? '#2979ff' : '#333',
                  }}
                >
                  {label}
                </div>
              ))}
            </div> */}
          </div>

          <img
            id="signup-base_logo_black_text"
            className={classes.logo}
            src="/base_logo_black_text.png"
            alt="VastReach"
          />
          {activeStep === 1 && (
            <h3 className={classes.pageTitle}>Start Your Free Trial Today!</h3>
          )}

          <div className={classes.stepContent}>
            <div className={classes.formFields}>
              {activeStep === 1 && (
                <>
                  <div className={classes.benefitsTitle}>What's your name?</div>
                  <Field
                    disabled={firstName}
                    style={{
                      backgroundColor: firstName ? '#f5f5f5' : '#fff',
                    }}
                    label="First name"
                    placeholder="Enter your first name"
                    value={this.state.firstName}
                    onChange={e =>
                      this.setState({ firstName: e?.target?.value })
                    }
                    type="text"
                  />
                  <Field
                    disabled={lastName}
                    style={{
                      backgroundColor: lastName ? '#f5f5f5' : '#fff',
                    }}
                    label="Last name"
                    placeholder="Enter your last name"
                    value={this.state.lastName}
                    onChange={e =>
                      this.setState({ lastName: e?.target?.value })
                    }
                    type="text"
                  />
                </>
              )}

              {activeStep === 2 && (
                <>
                  <div className={classes.benefitsTitle}>
                    📧 What's your email address?
                  </div>
                  <Field
                    disabled={email}
                    style={{
                      backgroundColor: email ? '#f5f5f5' : '#fff',
                    }}
                    label="Email address"
                    placeholder="Enter your email address"
                    value={this.state.email}
                    onChange={e =>
                      this.setState({
                        email: e?.target?.value,
                        username: e?.target?.value, // Set username same as email
                      })
                    }
                    type="email"
                  />
                </>
              )}

              {activeStep === 3 && PasswordStep}

              {activeStep === 4 && (
                <>
                  <div className={classes.benefitsTitle}>
                    📞 What's your phone number?
                  </div>
                  <div style={{ display: 'flex', marginBottom: '1.25rem' }}>
                    <div
                      aria-owns={
                        this.state.anchorEl ? 'simple-menu' : undefined
                      }
                      aria-haspopup="true"
                      onClick={e =>
                        /* !mobile && */ this.setState({
                          anchorEl: e?.currentTarget,
                        })
                      }
                      style={
                        // this.state.mobile
                        //   ? {
                        //       ...countryCodeDropdownStyles,
                        //       borderTop: '4px solid #2cb74d',
                        //       borderLeft: '4px solid #2cb74d',
                        //       borderBottom: '4px solid #2cb74d',
                        //     }
                        //   : {
                        //       ...countryCodeDropdownStyles,
                        //       borderTop: '4px solid #901964',
                        //       borderLeft: '4px solid #901964',
                        //       borderBottom: '4px solid #901964',
                        //     }
                        countryCodeDropdownStyles
                      }
                    >
                      <img
                        src={countryToFlagObj?.[this.state.country]}
                        alt={this.state.country}
                        style={{
                          marginRight: 5,
                          width: 25,
                          verticalAlign: 'middle',
                        }}
                      />{' '}
                      <Hidden smDown>
                        {countryToCodeObj?.[this.state.country]}
                      </Hidden>
                    </div>
                    <Menu
                      // disabled={mobile}
                      id="simple-menu"
                      anchorEl={this.state.anchorEl}
                      open={Boolean(this.state.anchorEl)}
                      onClose={() => this.setState({ anchorEl: null })}
                    >
                      <MenuItem
                        onClick={() => {
                          this.setState({ country: 'US', anchorEl: null })
                        }}
                        value="US"
                      >
                        <img
                          src={US}
                          alt="US"
                          style={{
                            marginRight: 5,
                            width: 25,
                            verticalAlign: 'middle',
                          }}
                        />
                        United States
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          this.setState({ country: 'CA', anchorEl: null })
                        }
                        value="CA"
                      >
                        <img
                          src={CA}
                          alt="CA"
                          style={{
                            marginRight: 5,
                            width: 25,
                            verticalAlign: 'middle',
                          }}
                        />
                        Canada
                      </MenuItem>
                    </Menu>
                    <input
                      disabled={mobile}
                      style={{
                        width: '72%',
                        display: 'inline-block',
                        borderRadius: '0 25px 25px 0',
                        backgroundColor: mobile ? '#c5c5c5' : '#fff',
                      }}
                      placeholder="Enter your phone number"
                      value={this.state.mobile}
                      onChange={e =>
                        this.setState({ mobile: e?.target?.value })
                      }
                      type="text"
                      className={classes.input}
                    />
                  </div>
                </>
              )}

              {activeStep === 5 && TermsOfServiceStep}

              {activeStep === 6 && (
                <>
                  <div className={classes.benefitsTitle}>
                    Confirm your account
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                    Please enter the verification code sent to your phone
                  </div>
                  <Field
                    label="Verification Code"
                    placeholder="Enter your code"
                    value={this.state.code}
                    onChange={e => this.setState({ code: e?.target?.value })}
                    type="text"
                  />
                  <div style={{ marginTop: '10px' }}>
                    <button
                      onClick={() => Auth.resendSignUp(this.state.username)}
                      className={classes.signInLink}
                    >
                      Resend code
                    </button>
                  </div>
                </>
              )}
            </div>

            {/* Benefits section with Hidden components */}
            <Hidden smDown>
              {benefitsSection}
              {questionsSection}
            </Hidden>
          </div>

          {/* Footer moved outside stepContent */}
          <div className={classes.footerContainer}>
            <div className={classes.footer}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                {activeStep > 1 && activeStep !== signupSteps.length - 1 && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => this.handleBack()}
                    style={{ padding: '6px 35px' }}
                  >
                    Back
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => this.handleNext()}
                  style={{
                    padding: '6px 35px',
                    marginLeft:
                      activeStep > 1 && activeStep !== signupSteps.length - 1
                        ? '0'
                        : 'auto',
                  }}
                >
                  {this.state.loading ? (
                    <CircularProgress
                      size={15}
                      classes={{
                        colorPrimary: classes.circularProgressColorPrimary,
                      }}
                    />
                  ) : activeStep === signupSteps.length - 1 ? (
                    'Create Account'
                  ) : (
                    'NEXT'
                  )}
                </Button>
              </div>
            </div>
          </div>

          {/* Benefits section for mobile */}
          <Hidden mdUp>{benefitsSection}</Hidden>
        </div>
      ),
      expired: (
        <>
          <h3 style={{ color: '#707070', textAlign: 'center' }}>
            YOUR INVITATION HAS EXPIRED.
            <br />
            PLEASE CONTACT YOUR ACCOUNT OWNER.
          </h3>
        </>
      ),
      failed: (
        <>
          {/* <img
            id="failed-line1282"
            className={classes.logo}
            src="/base_logo_black_text.png"
            alt="VastReach"
          /> */}
          <h3 style={{ color: '#707070', textAlign: 'center' }}>
            YOUR INVITATION HAS FAILED.
            <br />
            PLEASE CONTACT YOUR ACCOUNT OWNER.
          </h3>
        </>
      ),
      accepted: (
        <>
          <h3 style={{ color: '#707070', textAlign: 'center' }}>
            YOUR INVITATION HAS ALREADY BEEN ACCEPTED.
            <br />
            IF YOU'VE FORGOTTEN YOUR PASSWORD,{' '}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href="#"
              style={{ color: '#006fd9' }}
              onClick={e => {
                e.preventDefault()
                this.props.history.replace('/resetpassword')
                this.setState({ display: 'resetPassword' })
              }}
            >
              CLICK HERE
            </a>{' '}
            TO RESET IT
            <br />
            OR CONTACT YOUR ACCOUNT OWNER.
          </h3>
        </>
      ),
      invalid: (
        <>
          <h3 style={{ color: '#707070', textAlign: 'center' }}>
            YOUR INVITATION IS INVALID.
            <br />
            PLEASE CONTACT YOUR ACCOUNT OWNER.
          </h3>
        </>
      ),
      error: (
        <>
          <h3 style={{ color: '#707070', textAlign: 'center' }}>
            AN ERROR OCCURRED. PERHAPS TRY AGAIN LATER.
          </h3>
        </>
      ),
      datamismatch: (
        <>
          <h3 style={{ color: '#707070', textAlign: 'center' }}>
            THERE WAS A MISMATCH BETWEEN THE INVITATION LINK AND THE DATA
            PROVIDED 🤨
          </h3>
        </>
      ),
      alreadyAuthenticated: (
        <>
          <h3 style={{ color: '#707070', textAlign: 'center' }}>
            YOU ARE ALREADY SIGNED IN.
            <br />
            {this.props.location.pathname === '/userinvitation'
              ? acctID === this.props.acctID
                ? `IF YOU'RE TRYING CREATE ANOTHER USER FOR YOUR ACCOUNT,`
                : `IF YOU'RE TRYING TO ACCEPT AN INVITE FROM A DIFFERENT ACCOUNT,`
              : 'IF YOU WISH TO CREATE A NEW ACCOUNT,'}
            <br />
            PLEASE {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href="#"
              style={{ color: '#006fd9' }}
              onClick={e => {
                e.preventDefault()
                if (jwtToken) {
                  return window?.ReactNativeWebView?.postMessage?.('signout')
                } else {
                  userSignOut()
                }
              }}
            >
              SIGN OUT
            </a>{' '}
            TO CONTINUE.
          </h3>
        </>
      ),
      loading: (
        <>
          <h3 style={{ color: '#707070', textAlign: 'center' }}>LOADING...</h3>
        </>
      ),
      userinvitation: (
        <div className={classes.signupForm}>
          <div className={classes.progressContainer}>
            <LinearProgress
              variant="determinate"
              value={(activeStep / (userinvitationSteps.length - 1)) * 100}
              className={classes.linearProgress}
              classes={{
                barColorPrimary: classes.linearProgressColorPrimary,
              }}
            />
          </div>
          <img
            id="userinvitation-base_logo_black_text"
            className={classes.logo}
            src="/base_logo_black_text.png"
            alt="VastReach"
          />

          {this.state.activeStep === 1 && (
            <>
              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h3 style={{ color: '#333' }}>
                  😃 Hello {firstName},<br />
                  {inviter_fullname
                    ? inviter_fullname
                    : 'Your account owner'}{' '}
                  {inviter_company ? `from ${inviter_company}` : ''} has invited
                  you to their Vast Reach account.
                </h3>
                <p style={{ color: '#666' }}>
                  Please verify that your information is correct and run through
                  these simple steps to get started!
                </p>
                <p style={{ color: '#666', marginTop: '10px' }}>
                  If something looks wrong or you need to change these details
                  please{' '}
                  {inviter_email ? (
                    <Link
                      href={`mailto:${inviter_email}?subject=Request to update user information for ${firstName} ${lastName}`}
                      style={{ color: '#2979ff', textDecoration: 'underline' }}
                    >
                      send a message to{' '}
                      {inviter_fullname?.split(' ')?.[0] ||
                        'your account owner'}
                      .
                    </Link>
                  ) : (
                    `contact ${
                      inviter_fullname?.split(' ')?.[0] || 'your account owner'
                    }.`
                  )}
                </p>
              </div>

              <div className={classes.stepContent}>
                <div className={classes.formFields}>
                  <div className={classes.benefitsTitle}>
                    Verify your information
                  </div>
                  <Field
                    disabled
                    style={{ backgroundColor: '#f5f5f5' }}
                    label="First name"
                    value={this.state.firstName}
                    type="text"
                  />
                  <Field
                    disabled
                    style={{ backgroundColor: '#f5f5f5' }}
                    label="Last name"
                    value={this.state.lastName}
                    type="text"
                  />
                  <Field
                    disabled
                    style={{ backgroundColor: '#f5f5f5' }}
                    label="Email address"
                    value={this.state.email}
                    type="email"
                  />
                  <div style={{ display: 'flex', marginBottom: '1.25rem' }}>
                    <div
                      style={{
                        ...countryCodeDropdownStyles,
                        backgroundColor: '#f5f5f5',
                        cursor: 'default',
                      }}
                    >
                      <img
                        src={countryToFlagObj?.[this.state.country]}
                        alt={this.state.country}
                        style={{
                          marginRight: 5,
                          width: 25,
                          verticalAlign: 'middle',
                        }}
                      />
                      <Hidden smDown>
                        {countryToCodeObj?.[this.state.country]}
                      </Hidden>
                    </div>
                    <input
                      disabled
                      style={{
                        width: '72%',
                        display: 'inline-block',
                        borderRadius: '0 25px 25px 0',
                        backgroundColor: '#f5f5f5',
                      }}
                      value={this.state.mobile}
                      type="text"
                      className={classes.input}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {this.state.activeStep === 2 && PasswordStep}

          {this.state.activeStep === 3 && TermsOfServiceStep}

          {this.state.activeStep === 4 && ConfirmationCodeStep}

          <div className={classes.footerContainer}>
            <div className={classes.footer}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                {this.state.activeStep > 1 &&
                  this.state.activeStep !==
                    this.state.userinvitationSteps.length - 1 && (
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => this.handleBack()}
                      style={{ padding: '6px 35px' }}
                    >
                      Back
                    </Button>
                  )}
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    // Handle step transitions
                    if (this.state.activeStep === 1) {
                      this.setState({ activeStep: 2 })
                    } else if (this.state.activeStep === 2) {
                      // Validate password
                      if (this.validatePassword()) {
                        this.setState({ activeStep: 3 })
                      }
                    } else if (this.state.activeStep === 3) {
                      // Validate terms acceptance
                      if (this.state.termsAccepted) {
                        this.signUp()
                          .then(() => this.setState({ activeStep: 4 }))
                          .catch(err => {
                            this.props.openSnackbar({
                              type: 'error',
                              message: err?.message || 'An error occurred',
                            })
                          })
                      } else {
                        this.props.openSnackbar({
                          type: 'error',
                          message:
                            'Please accept the Terms of Service to continue',
                        })
                      }
                    } else if (
                      this.state.activeStep ===
                      userinvitationSteps.length - 1
                    ) {
                      this.confirmSignUp()
                    }
                  }}
                  style={{
                    padding: '6px 35px',
                    marginLeft:
                      this.state.activeStep > 1 &&
                      this.state.activeStep !==
                        this.state.userinvitationSteps.length - 1
                        ? '0'
                        : 'auto',
                  }}
                >
                  {this.state.loading ? (
                    <CircularProgress
                      size={15}
                      classes={{
                        colorPrimary: classes.circularProgressColorPrimary,
                      }}
                    />
                  ) : this.state.currentStep === 4 ? (
                    'Confirm'
                  ) : (
                    'Continue'
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      ),
      confirmSignup: (
        <>
          <img
            id="confirmSignup-base_logo_black_text"
            className={classes.logo}
            src="/base_logo_black_text.png"
            alt="VastReach"
          />
          <h3>Confirm Sign up</h3>
          <div className={classes.label}>Username *</div>
          <input
            disabled
            style={{ color: '#8b949d' }}
            value={this.state.username}
            onChange={e => this.setState({ username: e?.target?.value })}
            type="text"
            className={classes.input}
          />
          <div className={classes.label}>Confirmation Code</div>
          <input
            placeholder="Enter your code"
            value={this.state.code}
            onChange={e => this.setState({ code: e?.target?.value })}
            type="text"
            className={classes.input}
          />
          <div className="customAmplifyHint">
            Lost your code?{' '}
            <button
              onClick={() =>
                Auth.resendSignUp(this.state.username).then(
                  () => console.log('successfully resent code'),
                  err =>
                    this.props.openSnackbar({
                      type: 'error',
                      message: err?.message,
                    }),
                )
              }
              className="customAmplifyLink"
            >
              Resend code
            </button>
          </div>
          <div className={classes.footer}>
            <span className="customAmplifyFooterText">
              <button
                onClick={() => {
                  this.setState({ display: 'signin' })
                  history.push('/')
                }}
                className="customAmplifyLink"
              >
                Back to Sign In
              </button>
            </span>
            <button
              className="customAmplifyButton"
              onClick={() => this.confirmSignUp()}
            >
              {this.state.loading ? (
                <CircularProgress
                  size={15}
                  classes={{
                    colorPrimary: classes.circularProgressColorPrimary,
                  }}
                />
              ) : (
                'Confirm'
              )}
            </button>
          </div>
        </>
      ),
      signin: (
        <>
          <img className={classes.logo} src="/vast_logo.png" alt="VastReach" />
          <h3>Sign in to your account</h3>
          <div className={classes.label}>Username *</div>
          <input
            placeholder="Enter your username"
            value={this.state.username}
            onChange={e => this.setState({ username: e?.target?.value })}
            type="text"
            className={classes.input}
          />
          <div className={classes.label}>Password *</div>
          <input
            placeholder="Enter your password"
            value={this.state.password}
            onKeyDown={e => {
              if (e?.keyCode === 13) {
                this.signIn()
              }
            }}
            onChange={e => this.setState({ password: e?.target?.value })}
            type="password"
            className={classes.input}
          />
          <div className="customAmplifyHint">
            Forgot your password?{' '}
            <button
              onClick={() => this.setState({ display: 'resetPassword' })}
              className="customAmplifyLink"
            >
              Reset password
            </button>
          </div>
          <div className={classes.footer}>
            <span className="customAmplifyFooterText" style={{ color: '#fff' }}>
              No account?{' '}
              <button
                onClick={() => {
                  this.setState({ display: 'signup' })
                  history.push('/createaccount')
                }}
                className="customAmplifyLink"
              >
                Create account
              </button>
            </span>
            <button
              className="customAmplifyButton"
              onClick={() => this.signIn()}
            >
              {this.state.loading ? (
                <CircularProgress
                  size={15}
                  classes={{
                    colorPrimary: classes.circularProgressColorPrimary,
                  }}
                />
              ) : (
                'Sign In'
              )}
            </button>
          </div>
        </>
      ),
      resetPassword: (
        <>
          <img className={classes.logo} src="/vast_logo.png" alt="VastReach" />
          <h3>Reset your password</h3>
          <div className={classes.label}>Username *</div>
          <input
            value={this.state.username}
            onChange={e => this.setState({ username: e?.target?.value })}
            type="text"
            className={classes.input}
          />
          <div className={classes.footer}>
            <span className="customAmplifyFooterText">
              <button
                onClick={() => {
                  this.setState({ display: 'signin' })
                  history.push('/')
                }}
                className="customAmplifyLink"
              >
                Back to Sign In
              </button>
            </span>
            <button
              className="customAmplifyButton"
              onClick={() =>
                Auth.forgotPassword(this.state.username).then(
                  () => {
                    console.log('successfully sent forgot password code')
                    this.setState({ display: 'resetPasswordCode' })
                  },
                  err =>
                    this.props.openSnackbar({
                      type: 'error',
                      message: err?.message,
                    }),
                )
              }
            >
              Send code
            </button>
          </div>
        </>
      ),
      resetPasswordCode: (
        <>
          <img className={classes.logo} src="/vast_logo.png" alt="VastReach" />
          <h3>Reset your password</h3>
          <div className={classes.label}>Verification code</div>
          <input
            value={this.state.code}
            onChange={e => this.setState({ code: e?.target?.value })}
            type="text"
            className={classes.input}
          />
          <div className={classes.label}>New password</div>
          <input
            value={this.state.newPassword}
            onKeyDown={e => {
              if (e?.keyCode === 13) {
                this.signIn()
              }
            }}
            onChange={e => this.setState({ newPassword: e?.target?.value })}
            type="password"
            className={classes.input}
          />
          <div className={classes.footer}>
            <span className="customAmplifyFooterText">
              <button
                onClick={() => {
                  this.setState({ display: 'signin' })
                  history.push('/')
                }}
                className="customAmplifyLink"
              >
                Back to Sign In
              </button>
            </span>
            <button
              className="customAmplifyButton"
              onClick={() =>
                Auth.forgotPasswordSubmit(
                  this.state.username,
                  this.state.code,
                  this.state.newPassword,
                ).then(
                  () => {
                    console.log('successfully reset password')
                    this.setState({ display: 'signin' })
                    history.push('/')
                  },
                  err =>
                    this.props.openSnackbar({
                      type: 'error',
                      message: err?.message,
                    }),
                )
              }
            >
              Submit
            </button>
          </div>
        </>
      ),
    }

    const signupScreens = {
      signup: true,
      userinvitation: true,

      expired: true,
      loading: true,
      invalid: true,
      failed: true,
      accepted: true,
      datamismatch: true,
      error: true,
      alreadyAuthenticated: true,
    }

    const centerAlignItems = {
      expired: true,
      loading: true,
      invalid: true,
      failed: true,
      accepted: true,
      datamismatch: true,
      error: true,
      alreadyAuthenticated: true,
    }

    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          backgroundColor: signupScreens[this.state.display]
            ? '#fff'
            : '#014c94',
          overflowY: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: centerAlignItems[this.state.display]
            ? 'center'
            : 'normal',
        }}
      >
        {signupScreens[this.state.display] ? (
          <div
            style={{ width: '100%', maxWidth: '800px', margin: '40px 20px' }}
          >
            {centerAlignItems[this.state.display] ? (
              <img
                className={classes.logo}
                src="/base_logo_black_text.png"
                alt="VastReach"
              />
            ) : null}
            {displayObj[this.state.display]}
          </div>
        ) : (
          <div
            style={{
              backgroundColor: '#006fd9',
              color: '#fff',
            }}
            className={classes.form}
          >
            {displayObj[this.state.display]}
          </div>
        )}
      </div>
    )
  }
}

export default withRouter(
  connect(
    state => ({
      email: state.auth?.session?.idToken?.payload?.email,
      acctID: state.auth?.session?.idToken?.payload?.['custom:vr_account_id'],
    }),
    dispatch => bindActionCreators({ openSnackbar, userSignOut }, dispatch),
  )(withRoot(withStyles(styles)(SignUp))),
)
